import { ApiTask, TaskStatusCondition } from '~/api/types';
import { TaskTableRowData } from './TaskTableRowData';

/**
 * TaskTableData data class
 *
 * @category Data Classes
 *
 * @example
 * import { TaskTableData } from '~/data-classes/report';
 *
 * const srcData = [];
 * const reports = new TaskTableData(srcData);
 *
 */
export class TaskTableData {
    /**
     * The API source data
     * @type {ApiTask[]}
     */
    private readonly initApiTasks: ApiTask[];

    private readonly rawTasks: Record<string, TaskTableRowData>;

    private filtered: boolean;

    private filteredTasks: TaskTableRowData[];

    // No constructor JSDoc to avoid duplicates in generated docs
    // https://github.com/jsdoc/jsdoc/issues/1775
    constructor(initApiTasks: ApiTask[]) {
        this.initApiTasks = initApiTasks;

        this.rawTasks = this.initApiTasks.reduce((rawTasks, apiTask) => {
            const taskItem = new TaskTableRowData(apiTask);
            rawTasks[taskItem.id] = taskItem;
            return rawTasks;
        }, {} as Record<string, TaskTableRowData>);

        this.filteredTasks = [];

        this.filtered = false;
    }

    get tasks(): TaskTableRowData[] {
        return this.filtered
            ? this.filteredTasks
            : Object.values(this.rawTasks);
    }

    filterTasksByStatus(status = [] as TaskStatusCondition[]): this {
        this.filteredTasks = Object.values(this.rawTasks).filter((rawTask) => {
            return status.includes(rawTask.taskStatusCondition);
        });
        this.filtered = status.length > 0;
        return this;
    }

    /**
     * Serializes this class back to JSON
     * @returns {ApiTask[]}
     */
    toJSON(): ApiTask[] {
        return this.initApiTasks;
    }
}
